import NextApp, { type AppContext, type AppInitialProps } from 'next/app';
import React from 'react';
import '../styles/tailwind.css';
import log, { type LogLevelDesc } from 'loglevel';
import type { IAppProps } from '../features/app/root/domain/models/IAppProps';
import type { ICommonData } from '../features/app/root/domain/models/ICommonData';
import { getCommonData } from '../features/app/root/domain/use-cases/getCommonData';
import { App as BaseApp } from '../features/app/root/ui/App';
import { defaultLocale } from '../features/shared/i18n/locale/constants/default';
import { getLocaleFromPath } from '../features/shared/i18n/locale/getLocaleFromPath';

log.setLevel(process.env.LOG_LEVEL as LogLevelDesc);

const App = (props: IAppProps) => <BaseApp {...props} />;

export interface IAppInitialProps extends AppInitialProps {
	commonData: ICommonData;
}

App.getInitialProps = async (
	appContext: AppContext,
): Promise<IAppInitialProps> => {
	const nextAppProps = await NextApp.getInitialProps(appContext);
	const locale = getLocaleFromPath(appContext.router.asPath);

	log.debug('Detected locale', {
		path: appContext.router.asPath,
		locale,
	});

	const commonData = await getCommonData(locale ?? defaultLocale);

	return { ...nextAppProps, commonData };
};

export default App;
